import React, { useContext } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { CustomCard } from "../../../../shadcn/components/custom/CustomCard";
import { useRouter } from "next/router";
import { Context } from "services";

export default function ABVerified() {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  return (
    <>
      <div className="flex ">
        <div className="w-full p-6 lg:px-customPadding  mt-20 lg:pt-0  lg:pb-[53px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <div className="pt-8 lg:pt-[70px] bg-[#F8F8F8]">
            {/* Heading */}
            <div className="flex px-5 lg:px-0 justify-center ">
              <p className="font-spaceGrotesk text-center font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[59px] text-brand-textBlack ">
                AUCTION BAZAAR VERIFIED
              </p>
            </div>
            <div className="flex justify-center w-[310px] lg:w-[528px] mx-auto mt-3 lg:mt-4">
              <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-md leading-4 lg:leading-[19px] text-brand-textGrey text-center">
                Check out the collection of best properties from multiple cities
                hand selected and verified by Auction bazaar team
              </p>
            </div>

            {/* Button */}
            <div className="flex mt-5 lg:mt-9 justify-center">
              <Button
                className="py-3 px-8 lg:py-4 lg:px-7 justify-center bg-black"
                variant={"custom"}
                size={"custom"}
                onClick={() => {
                  // if (searchForm?.value?.city?.value) {
                  //   searchForm.setField("asset_type", "");
                  //   router.push(
                  //     `/auction-properties-in-${searchForm.value.city.value}?filter_by=auction_verified`
                  //   );
                  // } else {
                  router.push(`/auction-properties?filter_by=auction_verified`);
                  searchForm.setField("asset_type", "");
                  searchForm.setField("city", {
                    label: "all cities",
                    value: "",
                  });
                  // }
                }}
              >
                <p className="font-openSans font-semibold text-web-body-md leading-4 lg:text-[22px] lg:leading-[30px] text-brand-textWhite">
                  View verified properties
                </p>
              </Button>
            </div>

            {/* Image Component */}
            <div className=" flex justify-center px-[19px] lg:w-[577px] mx-auto mt-7 lg:mt-[44px] relative">
              <img
                src="/abverified.png"
                alt="min-h-[138px] w-auto"
                className="hidden lg:flex z-0 "
              />
              <div className=" relative lg:static">
                <img
                  src="/abverifiedmobile.png"
                  alt="min-h-[138px] w-auto"
                  className=" lg:hidden z-0 "
                />

                <CustomCard
                  alignment="top-[75px] lg:top-[62px] left-[35px] lg:-left-[110px]"
                  contentText="24x7 Support"
                />

                <CustomCard
                  alignment="top-[44px] lg:top-[50px] right-3 lg:-right-[65px]"
                  contentText="Property Photos"
                />

                <CustomCard
                  alignment="top-[145px] lg:top-[140px] left-[25px]  lg:-left-[45px]"
                  contentText=" Property Documents"
                />

                <CustomCard
                  alignment="hidden lg:flex top-[164px] -right-[148px] lg:-right-[110px] mid:-right-[128px]"
                  contentText="Property Details"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
